module.exports = {
  questions: [
    {
      id: 0,
      text: 'Which is your favourite animal?',
      answers: [
        {
          id: 1,
          text: 'Cats'
        },
        {
          id: 2,
          text: 'Dog'
        },
        {
          id: 3,
          text: 'Hamster'
        },
        {
          id: 4,
          text: 'Horse'
        }
      ],
      multiple_choice: true,
      custom: false
    }
  ],
  userData: {
    postalCode: 'm5r3b7'
  },
  institutions: [
    {
      id: 1,
      name: 'Appletree Health Clinic'
    }
  ],
  institutionLocations: [
    {
      id: 1,
      institution_id: 1,
      lat: -34.399,
      lng: 150.646,
      address: '199 street'
    },
    {
      id: 2,
      institution_id: 1,
      lat: -34.399,
      lng: 150.646,
      address: '199 street'
    }
  ]
};


// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/mockData.js